import { ImageResource, ImageWithAspectRatio } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";

const ImageWrapper = styled.div`
	${({ theme }) => theme.breakpoints.tablet} {
		grid-column: 1 / span 2;
	}

	padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

interface Props {
	image: ImageResource | null;
}

export const EventImage: FC<Props> = ({ image }) => {
	if (!image) {
		return null;
	}

	return (
		<ImageWrapper>
			<ImageWithAspectRatio image={image} alt={image.name} />
		</ImageWrapper>
	);
};
